<script>
import { mapActions, mapMutations } from 'vuex'
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import { emailErrors, passwordErrors, confirmPasswordErrors } from 'src/plugins/validations'

export default {
  props: {
    'open': Boolean, // Flag used to determine if the modal should be open or closed
    'toggle': Function // Changes the flag to typically a false state
  },
  validations: {
    signupForm: {
      email: { required, email },
      password: { required, minLength: minLength(6), maxLength: maxLength(20) },
      confirmPassword: { required, minLength: minLength(6), maxLength: maxLength(20), sameAs: sameAs('password') }
    }
  },
  data () {
    return {
      signupForm: this.$store.state.auth.signupForm
    }
  },
  computed: {
    emailErrors () { return emailErrors(this.$v.signupForm) },
    passwordErrors () { return passwordErrors(this.$v.signupForm) },
    confirmPasswordErrors () { return confirmPasswordErrors(this.$v.signupForm) },
    invalid () { return this.$v.signupForm.$invalid }
  },
  methods: {
    ...mapActions('auth', [
      'submitSignupForm'
    ]),
    ...mapMutations('auth', [
      'updateSignupForm'
    ])
  }
}
</script>

<template>
  <q-modal v-model="open" :content-css="{minWidth: '30vw', minHeight: '50vh'}">
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-btn
          flat
          round
          dense
          @click="toggle"
          icon="clear"
        />
        <q-toolbar-title>
          Signup
        </q-toolbar-title>
      </q-toolbar>

      <!-- <q-toolbar slot="header">
        <q-search inverted v-model="search" color="none" />
      </q-toolbar> -->

      <div class="layout-padding">
        <q-field class="q-pa-md">
          <q-input
            float-label="Email"
            :error-messages="emailErrors"
            :value="signupForm.email"
            @keyup.stop="updateSignupForm({field: 'email', value: $event.target.value})"
            @input="$v.signupForm.email.$touch()"
            @blur="$v.signupForm.email.$touch()"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md">
          <q-input
            float-label="Password"
            type="password"
            :error-messages="passwordErrors"
            :value="signupForm.password"
            @keyup.stop="updateSignupForm({field: 'password', value: $event.target.value})"
            @input="$v.signupForm.password.$touch()"
            @blur="$v.signupForm.password.$touch()"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md">
          <q-input
            float-label="Confirm Password"
            type="password"
            :error-messages="confirmPasswordErrors"
            :value="signupForm.confirmPassword"
            @keyup.stop="updateSignupForm({field: 'confirmPassword', value: $event.target.value})"
            @input="$v.signupForm.confirmPassword.$touch()"
            @blur="$v.signupForm.confirmPassword.$touch()"
            required>
          </q-input>
        </q-field>
      </div>

      <q-toolbar slot="footer">
        <q-toolbar-title>
        </q-toolbar-title>
        <q-btn
          color="primary"
          label="Submit"
          @click.native="submitSignupForm()"
          :disabled="invalid"
        />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>
